














































import commons from "@/common/store/modules/commons";
import TheL01EmptyPanel from "@/general/components/pages/parts/WhatsNewList/TheL01EmptyPanel.vue";
import TheL01NewsList from "@/general/components/pages/parts/WhatsNewList/TheL01NewsList.vue";
import TheTemplateL from "@/general/components/templates/TheTemplateL.vue";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import store from "@/general/store";
import { availableMonths, getWhatsNewList } from "@/general/store/api";
import { WhatsNewListResponse } from "@/general/store/models";
import globals from "@/general/store/modules/globals";
import { DateMonth } from "gen/ricapi/api";
import { Component, Vue } from "vue-property-decorator";
import { checkLengthInput } from "@/general/utils/helper";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheTemplateL,
    TheL01NewsList,
    TheL01EmptyPanel
  },
  store: store
})
export default class WhatsNew extends Vue {
  search = "";
  searchCount: number | undefined = 0;
  heading = "";
  error = "";
  filterHeading = "すべての期間";
  isLoading = true;
  monthNames = [
    "すべての期間",
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ];

  searchKeyword = "";

  newsList: any = [];

  sorted: any = {
    target: "all",
    shownState: false,
    itemList: [
      {
        id: "all",
        value: "all",
        label: "すべての期間"
      }
    ]
  };

  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };

  availableMothsList!: DateMonth[] | undefined;

  currentPage!: number;
  slug!: string;
  showNotFound = false;
  breadcrumb = [
    {
      text: "",
      url: SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "お知らせ一覧",
      url: "",
      pageType: "lower"
    }
  ];

  get newsListExists() {
    return this.newsList.length > 0;
  }

  get showSearchCount() {
    return this.searchKeyword && this.newsListExists;
  }

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  async loadWhatsNewList() {
    const search =
      LocalStorage.getItem("whatsNewSearch") !== null
        ? (LocalStorage.getItem("whatsNewSearch") as string)
        : "";
    const filterMonth =
      LocalStorage.getItem("whatsNewMonth") !== null
        ? (LocalStorage.getItem("whatsNewMonth") as string)
        : undefined;
    const filterYear =
      LocalStorage.getItem("whatsNewYear") !== null
        ? (LocalStorage.getItem("whatsNewYear") as string)
        : undefined;

    const filterPosition =
      LocalStorage.getItem("whatsNewPosition") !== null
        ? (LocalStorage.getItem("whatsNewPosition") as string)
        : 0;

    const response: WhatsNewListResponse = await getWhatsNewList(
      this.currentPage,
      this.pageSize,
      search,
      filterMonth,
      filterYear
    );

    this.searchCount = response.count as number;

    if (this.searchCount > 0) {
      this.showNotFound = false;
      this.newsList = response?.results;
    } else {
      this.showNotFound = true;
      this.newsList = [];
    }

    this.setPagination(
      this.searchCount,
      filterYear,
      filterMonth,
      filterPosition
    );
    this.setFilterPosition(filterPosition);
    this.searchKeyword = search;
    this.isLoading = false;
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.getBreadcrumb(this.breadcrumb);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";
    this.searchKeyword = search;
    LocalStorage.setItem("whatsNewSearch", this.searchKeyword);

    const filterYear = urlParams.get("filterYear")
      ? (urlParams.get("filterYear") as string)
      : "";

    const filterMonth = urlParams.get("filterMonth")
      ? (urlParams.get("filterMonth") as string)
      : "";

    const filterPosition = urlParams.get("filterPosition")
      ? (urlParams.get("filterPosition") as string)
      : "";

    if (filterYear == "" || filterMonth == "" || filterPosition == "") {
      LocalStorage.removeItem("whatsNewYear");
      LocalStorage.removeItem("whatsNewMonth");
      LocalStorage.removeItem("whatsNewPosition");
    } else {
      LocalStorage.setItem("whatsNewYear", filterYear);
      LocalStorage.setItem("whatsNewMonth", filterMonth);
      LocalStorage.setItem("whatsNewPosition", filterPosition);
    }

    this.currentPage = pageParam ? parseInt(pageParam) : 1;
    this.getAvailableMonths();
    this.doSearch(this.searchKeyword, this.currentPage);
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  get internalSearch() {
    return this.search;
  }

  set internalSearch(newValue: string) {
    if (this.search !== newValue) this.$emit("update:search", newValue);
  }

  async doSort($event: any) {
    this.isLoading = true;
    const str = $event;
    this.currentPage = 1;

    let month: string;
    let year: string;
    let position = 0;

    if (str.split(" ").length === 1) {
      year = "";
      month = "";
      position = 0;
    } else {
      year = str.split(" ")[0];
      month = str.split(" ")[1];
      position = str.split(" ")[2];
    }

    LocalStorage.setItem("whatsNewMonth", month);
    LocalStorage.setItem("whatsNewYear", year);
    LocalStorage.setItem("whatsNewPosition", position.toString());
    
    await this.loadWhatsNewList();

    this.setNewUrl();
  }

  async doSearch(search: string, currentPage: number) {
    this.isLoading = true;
    this.search = search;
    this.searchKeyword = search;
    this.currentPage = currentPage;
    const checkValidLength = checkLengthInput(this.searchKeyword, 50);
    if (!checkValidLength?.isValid) {
      this.error = checkValidLength?.error;
      this.showNotFound = true;
      this.newsList = [];
      return false;
    }

    LocalStorage.setItem("whatsNewSearch", search);

    await this.loadWhatsNewList();

    this.setNewUrl();
  }

  setNewUrl(){
    const title = document.title;
    const newUrl = `${this.pageNavi.baseUrl}&page=${this.currentPage}&search=${this.searchKeyword}`;
    window.history.replaceState({}, title, newUrl);
  }

  async getAvailableMonths() {
    const res = await availableMonths();
    this.sorted.itemList = [
      {
        id: "all",
        value: "all",
        label: "すべての期間"
      }
    ];
    res.data.results?.forEach((obj: any, i: number) => {
      this.sorted.itemList.push({
        id: obj.year.toString() + " " + obj.month.toString(),
        value: obj.year.toString() + " " + obj.month.toString() + " " + (i + 1),
        label: obj.year.toString() + "年" + " " + this.monthNames[obj.month]
      });
    });
  }

  setFilterPosition(position: string | number) {
    this.sorted.shownState = false;
    this.filterHeading = this.sorted.itemList[position].label;
  }

  setPagination(
    rowCount: number,
    filterYear: string | undefined,
    filterMonth: string | undefined,
    filterPosition: string | number) {
    const maxPage =
      rowCount % this.pageSize >= 1
        ? Math.floor(rowCount / this.pageSize) + 1
        : rowCount / this.pageSize;
    const year = filterYear === undefined ? "" : filterYear;
    const month = filterMonth === undefined ? "" : filterMonth;

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = `${SITE_MAP.WHATS_NEW}?filterYear=${year}&filterMonth=${month}&filterPosition=${filterPosition}`;
    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }
    const nextPage = this.currentPage + 1;

    this.pageNavi.nextPageUrl = `${this.pageNavi.baseUrl}&page=${nextPage}&search=${this.searchKeyword}`;
    this.pageNavi.prevPageUrl = `${this.pageNavi.baseUrl}&page=${prevPage}&search=${this.searchKeyword}`;

  }
}
